import React, {Fragment, useContext} from "react"
import AppSidebarGroup from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarGroup";
import AppSidebarMenuItem from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarMenuItem";
import {getResourcesRouterLink} from "root/Wieldy/routePaths";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {PostFilters, ResourceTypeFilters} from "root/DataFunctions/Constants";
import useModalAddResource from "root/Modals/AddResource/useModalAddResource";
import WieldySidebarSection from "root/Wieldy/Sidebar/WieldySidebarSection";
import WieldySidebarClick from "root/Wieldy/Sidebar/WieldySidebarClick";

const ResourcesSubmenu = (props ) =>
{
    const {search} = useLocation();
    const queryParams = queryString.parse(search);

    // Open add resource modal
    const [renderAddResourceModal, showAddResourceModal] = useModalAddResource((result) =>
    {
        if (result === 'saved')
        {
            //getData();
        }
    })

    const clickHandler = (event) =>
    {
        showAddResourceModal('create', null);
    }

    // Ensure we always have a default filter ( From the URL or a default )
    const resource_filter_type = queryParams.type === undefined ? ResourceTypeFilters.FEELINGS : queryParams.type;

    const resourcesSubmenu =() =>{
        return(
            <AppSidebarGroup title='Filters' default={resource_filter_type}>
                <AppSidebarMenuItem link={getResourcesRouterLink('?type=feelings')} title='Feelings' iconName='icon-contacts' name={ResourceTypeFilters.FEELINGS} />
                <AppSidebarMenuItem link={getResourcesRouterLink('?type=learning')} title='Learning' iconName='icon-graduation' name={ResourceTypeFilters.LEARNING}/>
                <AppSidebarMenuItem link={getResourcesRouterLink('?type=game')} title='Games' iconName='icon-inbuilt-apps' name={ResourceTypeFilters.GAME}/>
                <AppSidebarMenuItem link={getResourcesRouterLink('?type=help')} title='Help' iconName='icon-question-circle' name={ResourceTypeFilters.HELP}/>
                <AppSidebarMenuItem link={getResourcesRouterLink('?type=all')} title='All Resources' iconName='icon-files' name={ResourceTypeFilters.ALL}/>

                <WieldySidebarSection title='New Resource' >
                    <WieldySidebarClick modal={(event) => clickHandler(event)} title='Resource' iconName='icon-add-circle' iconSize='icon-xl' keyName='root1' key='c1'/>
                </WieldySidebarSection>
            </AppSidebarGroup>
        )
    }

    return (
        <Fragment>
            { resourcesSubmenu ()}
            {renderAddResourceModal(props)}
        </Fragment>
    )
}

export default ResourcesSubmenu ;